<template lang="html">
  <div class="container-fluid">
    <d-row class="row-table">
      <d-col class="col-table" v-if="!isCustomer">
        <table class="table mb-0 table-striped">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0">Todos os Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in detachedStatus" :key="index">
              <td :class="['td-4', isSelected(row) ? 'selected' : '']" @click="selectRow(row, 'attached')">
                <span>{{ row.name }}</span>
              </td>
            </tr>
            <tr v-if="detachedStatus.length === 0">
              <td class="no-content">Ainda não tem nenhum status cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </d-col>
      <d-col cols="1" class="d-flex align-items-center justify-content-center" v-if="!isCustomer">
        <d-button class="btn-outline-info btn-sm" @click="sync">
          <i class="material-icons">sync_alt</i>
        </d-button>
      </d-col>
      <d-col class="col-table">
        <table class="table-sync table mb-0 table-striped">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0">Status Relacionados</th>
            </tr>
          </thead>
          <draggable
            v-model="attachedStatus"
            group="people"
            tag="tbody"
            ghost-class="ghost"
            draggable=".draggable-item"
            @start="drag=true"
            @end="drag=false"
            :disabled="isCustomer"
          >
            <tr
              v-for="(row, index) in attachedStatus"
              :key="index"
              :class="['drag-row align-items-center', isSelected(row) ? 'selected' : '', row.disabled ? 'no-content text-left' : 'draggable-item']"
              @click="selectRow(row, 'detached')">
              <td class="td-2" >
                <i class="fa fa-align-justify handle"></i>
                <span>{{ row.name }}</span>
              </td>
              <td class="td-2 text-right">
                <span>{{ row.f_finished_at }}</span>
              </td>
            </tr>
            <tr v-if="attachedStatus.length === 0" class="drag-row align-items-center">
              <td class="no-content">Ainda não tem nenhum status atribuido.</td>
            </tr>
          </draggable>
        </table>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import { mapActions } from 'vuex';
import { MODEL_PROJECT_STATUS, ATTACHED, DETACHED } from '../ProjectModel';

export default {
  name: 'project-status',
  components: {
    draggable,
  },
  data() {
    return {
      type: ATTACHED,
      timer: null,
      projectId: null,
      statusSelected: [],
    };
  },
  computed: {
    detachedStatus() {
      const { detachedStatus } = this.$store.state.project;
      if (detachedStatus) {
        return detachedStatus;
      }
      return [];
    },
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
    attachedStatus: {
      get() {
        const { attachedStatus } = this.$store.state.project;
        if (attachedStatus) {
          return attachedStatus;
        }
        return [];
      },
      set(attachedStatus) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.syncAttacherStaus({ attachedStatus, projectId: this.projectId })
            .then(this.saveSuccess)
            .catch(this.saveError);
        }, 800);
      },
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'setAttachedStatus',
      'syncAttacherStaus',
      'getAttachedProjectStatus',
    ]),
    attach() {
      this.setAttachedStatus(this.preparAttached());
      this.syncAttacherStaus({ attachedStatus: this.attachedStatus, projectId: this.projectId })
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
    detach() {
      this.setAttachedStatus(this.preparDetached());
      this.syncAttacherStaus({ attachedStatus: this.attachedStatus, projectId: this.projectId })
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
    getStatus() {
      this.getAttachedProjectStatus({ projectId: this.projectId, group: ATTACHED });
      this.getAttachedProjectStatus({ projectId: this.projectId, group: DETACHED });
    },
    isSelected(row) {
      if (this.statusSelected.includes(row)) {
        return true;
      }
      return false;
    },
    preparAttached() {
      return this.attachedStatus.concat(this.statusSelected.map((row, index) => (
        // eslint-disable-next-line
        { ...MODEL_PROJECT_STATUS, ...{ name: row.name, order: index, project_id: this.projectId, status_id: row.id }}
      )));
    },
    preparDetached() {
      return this.attachedStatus.filter(row => !this.statusSelected.includes(row));
    },
    saveError(error) {
      this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
    },
    saveSuccess() {
      this.statusSelected = [];
      this.getStatus();
      this.activeAlert({ message: 'Sincronização salva com sucesso', theme: 'success' });
    },
    selectRow(row, type) {
      if (type !== this.type) {
        this.type = type;
        this.statusSelected = [];
      }
      if (row.disabled) {
        return false;
      }
      const index = this.statusSelected.indexOf(row);
      if (index > -1) {
        return this.statusSelected.splice(index, 1);
      }
      return this.statusSelected.push(row);
    },
    sync() {
      if (this.type === ATTACHED) {
        return this.attach();
      }
      return this.detach();
    },
  },
  mounted() {
    this.projectId = parseInt(this.$route.params.projectId, Number);
    this.getStatus();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.drag-row {
  padding-top: 10px;
  margin: 0;
  cursor: move;
  .handle {
    padding-right: 10px;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.row-table {
  display: flex;
  height: 100%;
  .col-table {
    height: 100%;
    padding: 0;
    border: 1px solid;
    border-radius: 0.3rem;
  }
}

.table {
  .no-content {
    vertical-align: middle;
  }
  .selected {
    background: lighten($cyan, 45%);
  }
  &-sync {
    tr td{
      height: 47px;
    }
  }
}
.btn-outline-info {
  font-size: 1.4rem;
  padding: 0px 20px;
}
</style>
